
import {Image} from '@shopify/hydrogen';
  
  export function Logo(){
    return (
      <Image
      src="https://a.storyblok.com/f/173679/1318x253/fc069ecd2c/logo-white.png" loading="lazy" 
      width={500}
      height={300}
      alt="Logo Invog"
      className="object-contain w-[500px]
      surface-only:w-[200px]
      xl:w-60"
    />

);
  }
